import { NgModule, Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'naturalSort'
})
export class NaturalSortPipe implements PipeTransform {

  transform(array: any[] = [], key: string, reverse?: boolean): any[] {
    const natCache = {};

    const arr = array.sort((a, b) => {
      const aK = natValue(a[key]);
      const bK = natValue(b[key]);
      return (aK < bK) ? -1 : ((aK > bK) ? 1 : 0);
    });

    if (reverse) {
      arr.reverse();
    }

    return arr;

    function padding(value) {
      return '000'.slice(value.length);
    }

    function fixNumbers(value) {
      if (!value) {
        return;
      }
      value = value.toString();
      return value.replace(/(\d+)((\.\d+)+)?/g, function ($0, integer, decimal, $3) {
        if (decimal !== $3) {
          return $0.replace(/(\d+)/g, function ($d) {
            return padding($d) + $d;
          });
        } else {
          decimal = decimal || '.0';
          return padding(integer) + integer + decimal + padding(decimal);
        }
      });
    }

    function natValue(value) {
      if (natCache[value]) {
        return natCache[value];
      }
      const newValue = fixNumbers(value);
      return natCache[value] = newValue;
    }
  }

}

@NgModule({
  imports: [],
  declarations: [NaturalSortPipe],
  exports: [NaturalSortPipe]
})
export class NaturalSortPipeModule { }
